<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="订单编号：">
            <el-input v-model="query.orderNum" placeholder="请输入订单编号" clearable size="small" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="处理结果：">
            <el-select v-model="query.result" placeholder="全部" clearable size="small">
              <el-option label="处理中" :value="0"></el-option>
              <el-option label="自动完成" :value="1"></el-option>
              <el-option label="已跳过未流转" :value="2"></el-option>
              <el-option label="处理失败" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间：">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
            />
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleReset" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top: 10px;">
      <el-table v-loading="listLoading" :data="list" border fit highlight-current-row>
        <el-table-column label="订单编号" prop="orderNum" min-width="180">
          <template slot-scope="{ row }">
            <!-- 订单详情是商城订单页里的弹层、不是独立路由，所以跳到列表并带上订单号，
                 落地即是筛选好的那一条，点开就是详情 -->
            <el-link type="primary" v-if="row.orderNum" @click="goOrder(row)">{{ row.orderNum }}</el-link>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="处理结果" prop="resultName" width="130" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="resultTagType(row.result)" size="small">{{ row.resultName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="原因" prop="reason" min-width="260" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.reason || '-' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdTime" width="170" align="center" />
        <el-table-column label="更新时间" prop="operatedTime" width="170" align="center">
          <template slot-scope="{ row }">{{ row.operatedTime || '-' }}</template>
        </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { getVirtualAutoLogList } from '@/api/order/virtualAutoLog'
import { virtualOrderTarget } from '@/utils/virtual-order-navigation'

/**
 * 虚拟单自动流转记录（REQ-2026-826259）
 *
 * 虚拟商品订单支付成功后由 App 后端自动流转成已完成、不发货。
 * 这个页面给运营看流转结果：失败/跳过的能看到原因，点订单号跳过去人工处理。
 * 只读，没有任何写操作。
 */
export default {
  name: 'VirtualAutoLogList',
  components: { Pagination },
  data() {
    return {
      listLoading: false,
      list: [],
      total: 0,
      dateRange: [],
      query: {
        pageNo: 1,
        pageSize: 20,
        orderNum: undefined,
        result: undefined,
        startDate: undefined,
        endDate: undefined
      }
    }
  },
  created() {
    this.doQueryList()
  },
  methods: {
    resultTagType(result) {
      switch (result) {
        case 1: return 'success'
        case 3: return 'danger'
        case 2: return 'warning'
        default: return 'info'
      }
    },
    doQueryList() {
      this.listLoading = true
      this.query.startDate = this.dateRange && this.dateRange.length ? this.dateRange[0] : undefined
      this.query.endDate = this.dateRange && this.dateRange.length ? this.dateRange[1] : undefined
      getVirtualAutoLogList(this.query).then(({ data }) => {
        this.list = (data && data.list) || []
        this.total = (data && data.total) || 0
      }).finally(() => {
        this.listLoading = false
      })
    },
    handleQuery() {
      this.query.pageNo = 1
      this.doQueryList()
    },
    handleReset() {
      this.dateRange = []
      this.query.orderNum = undefined
      this.query.result = undefined
      this.query.pageNo = 1
      this.doQueryList()
    },
    goOrder(row) {
      const target = virtualOrderTarget(row)
      if (!target) {
        this.$message.warning('无法读取订单当前状态，请在商城订单中按订单号查询')
        return
      }
      this.$router.push(target)
    }
  }
}
</script>
